




import { defineComponent } from '@nuxtjs/composition-api';
import { DcwCareerListing } from '@/components/Layouts/CareerListing/DcwCareerListing.vue';
import { useLocales, usePage } from '@/composables';
import { ListingContentTypes, Pages, PagesLinks } from '@/types';
import { offersService, projectsService } from '@/service/model';

export default defineComponent({
  components: { DcwCareerListing },
  layout: 'Default',
  setup() {
    const { translation } = useLocales();
    const { offers } = offersService;
    const { content: projects } = projectsService;

    const listingProps = {
      offers,
      projects,
      hero: translation.listings.career,
      activeOption: ListingContentTypes.PROJECTS
    };

    usePage({
      data: Pages.PROJECTS,
      breadcrumbs: [
        { name: translation.pagesNames.home, url: PagesLinks.HOME },
        { name: translation.pagesNames.career, url: PagesLinks.CAREER },
        { name: translation.pagesNames.projects, url: PagesLinks.PROJECTS }
      ]
    });

    return { listingProps };
  },
  nuxtI18n: {
    locales: ['en']
  },
  head: {}
});
